import styles from "./NewLoading.module.scss";

export const LoadingDotBars = (props: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <>
      <div className={styles.loading_wrapper} {...props}>
        <div className={styles.dot_bars}></div>
      </div>
    </>
  );
};
